import React from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
} from 'react-bootstrap';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import UserService from '#/services/UserService';

function SignupConfirm() {
  const { control, handleSubmit } = useForm();
  const { code, email } = useParams();
  const service = new UserService();
  const navigate = useNavigate();

  const onSubmit = async (values: any) => {
    try {
      await service.verify(
        values.email,
        values.password,
        code!,
        values.name,
        values.owner_device_id,
        values.child_device_id
      );

      navigate('/');

    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Container
      fluid
      className="h-100 mt-4 justify-content-center align-items-center w-50"
    >
      <Row>
        <Col>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Control type="hidden" name="code" value={code} />
            <Form.Group className="mb-3">
              <Form.Label>メールアドレス</Form.Label>
              <Controller
                control={control}
                name="email"
                defaultValue={email}
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="email"
                    plaintext
                    value={value}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>パスワード</Form.Label>
              <Controller
                control={control}
                name="password"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="password"
                    value={value}
                    ref={ref}
                    onChange={onChange}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>名称</Form.Label>
              <Controller
                control={control}
                name="name"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="edit"
                    onChange={onChange}
                    ref={ref}
                    name="name"
                    value={value}
                  />
                )}
              />
            </Form.Group>
            <Card className="mb-3">
              <Card.Header>オプション（後から登録可能）</Card.Header>
              <Card.Body>
                <Form.Group className="mb-3">
                  <Form.Label>親機識別ID</Form.Label>
                  <Controller
                    control={control}
                    name="owner_device_id"
                    render={({ field: { onChange, value, ref } }) => (
                      <Form.Control
                        type="edit"
                        onChange={onChange}
                        ref={ref}
                        name="owner_device_id"
                        value={value}
                      />
                    )}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>子機識別ID</Form.Label>
                  <Controller
                    control={control}
                    name="child_device_id"
                    render={({ field: { onChange, value, ref } }) => (
                      <Form.Control
                        type="edit"
                        onChange={onChange}
                        value={value}
                        ref={ref}
                        name="child_device_id"
                      />
                    )}
                  />
                </Form.Group>
              </Card.Body>
            </Card>
            <Form.Group className="text-center">
              <Button type="submit" className="w-75">
                新規登録
              </Button>
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default SignupConfirm;
